import { KeyValueModel } from "model";
import { EnumTipoFiltroData } from "model/enums/enum-tipo-filtro-data";

export const TipoFiltroDataMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoFiltroData.Vencimento, "Vencimento"),
    new KeyValueModel(EnumTipoFiltroData.Pagamento, "Pagamento"),
    new KeyValueModel(EnumTipoFiltroData.Emissao, "Emissão"),
    new KeyValueModel(EnumTipoFiltroData.Cancelamento, "Cancelamento"),
    new KeyValueModel(EnumTipoFiltroData.Bonificacao, "Bonificação")
];